module.exports = __webpack_public_path__ + "img/caiwutongji.b7888b7b.svg";